import { SelectOption } from 'global';
import { TextFieldProps } from '@mui/material';
import { AutocompleteProps } from '@mui/material/Autocomplete';
import { FACT_NAMES_BOOLEAN, FACT_NAMES_NUMERIC, FACT_NAMES_STRING } from '@trnsact/trnsact-scorecard-sdk';

import { convertFactToSelectOptions } from '../lib';

export const factNamesNumeric = convertFactToSelectOptions(FACT_NAMES_NUMERIC);
export const factNamesBoolean = convertFactToSelectOptions(FACT_NAMES_BOOLEAN);
export const factNamesString = convertFactToSelectOptions(FACT_NAMES_STRING);

export const allFacts = [...factNamesNumeric, ...factNamesString, ...factNamesBoolean];

const comparableLoanHistoryOptions = ['default', 'none', 'clean'].map(v => ({ value: v, label: v })) as SelectOption[];
const driverStructureOptions = ['leased', 'w2', 'owner'].map(v => ({ value: v, label: v })) as SelectOption[];
const homeOwnershipOptions = ['rents', 'owns'].map(v => ({ value: v, label: v })) as SelectOption[];

export const autocompletePropsByType: Partial<
  Record<
    FACT_NAMES_STRING,
    Omit<AutocompleteProps<SelectOption, true, false, false>, 'renderInput'> & {
      textFieldProps?: Partial<TextFieldProps>;
    }
  >
> = {
  [FACT_NAMES_STRING.COMPARABLE_LOAN_HISTORY]: {
    textFieldProps: {
      required: true,
      label: 'Select the Comparable Loan History',
    },
    options: comparableLoanHistoryOptions,
  },
  [FACT_NAMES_STRING.DRIVER_STRUCTURE]: {
    textFieldProps: {
      required: true,
      label: 'Select a Driver Structure',
    },
    options: driverStructureOptions,
  },
  [FACT_NAMES_STRING.HOME_OWNERSHIP]: {
    textFieldProps: {
      required: true,
      label: 'Select a Home Ownership',
    },
    options: homeOwnershipOptions,
  },
};

export const booleanOptions = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];
